// extracted by mini-css-extract-plugin
export default {"root":"IconHeart_root__4ETas"};